export const addTokenToHeaders = (token: string, contentType?: string) => ({
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': contentType ?? undefined,
  },
})
